import script from "./PalaRiffleUniversity.vue?vue&type=script&setup=true&lang=ts"
export * from "./PalaRiffleUniversity.vue?vue&type=script&setup=true&lang=ts"

import "./PalaRiffleUniversity.vue?vue&type=style&index=0&id=563d312a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-563d312a"]])

export default __exports__